import { render, staticRenderFns } from "./invitationsHandler.vue?vue&type=template&id=8d9752ba&"
import script from "./invitationsHandler.vue?vue&type=script&lang=js&"
export * from "./invitationsHandler.vue?vue&type=script&lang=js&"
import style0 from "./invitationsHandler.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports